<template>
  <div class="role">
    <query-select
      ref="queryselect"
      :status="status"
    ></query-select>
    <div class="page">
      <div class="page-header white-bg">
        <size-change @sizeChange="sizeChange"></size-change>
        <div class="header-right">
          <vs-input
            class="search-words"
            v-model="words"
            placeholder="请输入"
          ></vs-input>
          <vs-button class="search-btn" type="filled" color="primary" @click="toQuery">搜索</vs-button>
          <vs-button v-if="multipleFlag" class="search-btn" type="filled" color="primary" @click="multipleHandle">批量{{text}}</vs-button>
        </div>
      </div>
      <div class="page-content white-bg">
        <vs-table
          :data="listData"
          :multiple="isMultiple"
          v-model="selected"
        >
          <template slot="thead">
            <vs-th>
              订单号
            </vs-th>
            <vs-th>
               客户
            </vs-th>
            <vs-th class="channel-th">
              渠道
            </vs-th>
            <vs-th class="type-th">
              类型
            </vs-th>
            <vs-th class="amount-th">
              金额(USDT)
            </vs-th>
            <vs-th>
              来源/去向
            </vs-th>
            <vs-th class="remark-th">
              备注
            </vs-th>
            <vs-th>
              订单时间
            </vs-th>
            <vs-th class="status-th">
              订单状态
            </vs-th>
            <vs-th class="do-th" v-if="status === 0">
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data" >
              <vs-td
                @click.native.stop="orderIdHandle(data[index])"
                :data="data[index].transactionId">
                <span
                  class="order-span"
                  :class="{on: getActive(data[index])}">{{data[index].transactionId}}</span>
              </vs-td>

              <vs-td :data="data[index].phone">
                <div>{{data[index].phone}}</div>
                <div>{{data[index].address}}</div>
              </vs-td>

              <vs-td class="channel-th" :data="data[index].channel">
                <div>{{getChannelType(data[index])}}</div>
              </vs-td>
              <vs-td class="type-th">
                {{getType(data[index])}}
              </vs-td>
              <vs-td class="amount-th" :class="{red: data[index].type == 3}" :data="data[index].amount">
                {{data[index].amount}}
                <span v-if="data[index].type == 3">(手续费 {{data[index].payFee}})</span>
              </vs-td>
              <vs-td :data="data[index].relatedPhone">
                <div>{{data[index].relatedPhone}}</div>
                <div>{{data[index].relatedAddress}}</div>
              </vs-td>
              <vs-td class="remark-th" :data="data[index].remark">
                {{data[index].remark}}
              </vs-td>
              <vs-td :data="data[index].createTime">
                {{data[index].createTime}}
              </vs-td>
              <vs-td class="status-th">
                <span
                  class="asset-status"
                  :class="{
                  red: data[index].status == 1,
                  grey: data[index].status == 5,
                  }"
                >{{getStatus(data[index])}}</span>
              </vs-td>
              <vs-td class="remark-th" v-if="status === 0">
                <div class="centerx">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="支付"
                    placement="top"
                  >
                    <icon-svg
                      v-if="data[index].status == 2"
                      @click.native.stop="payHandle(data[index])"
                       icon-class="audit1"
                      class="pointer done-icon"
                    ></icon-svg>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="审核"
                    placement="top"
                  >
                    <icon-svg
                      v-if="data[index].status == 1"
                      @click.native="auditHandle(data[index])"
                      icon-class="credit-card1"
                      class="pointer audit-icon done-icon"
                    ></icon-svg>
                  </el-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="pagination-outer" v-if="total">
          <span class="tatol-count">共计{{total}}条</span>
          <vs-pagination
            class="pagination-box"
            :max="size"
            :total="pageSize"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
    </div>
    <audit-dialog
      :active="auditDialogShow"
      @close="closeAuditDialog"
      @send-form="sureHandle"
    ></audit-dialog>
    <pay-dialog
      :active="payDialogShow"
      :orderList="orderList"
      @close="closePayDialog"
      @send-ids="acceptIds"
    ></pay-dialog>
  </div>
</template>

<script>
  import payDialog from '../../../components/walletManage/assets/payDialog'
  import { auditWalletTrans,payWalletTrans } from '@/api/wallet'
  import auditDialog from '../../../components/walletManage/auditDialog'
  import  querySelect from '@/components/walletManage/assets/querySelect'
  import editOrAdd from '@/components/product/productList/editOrAdd'
  import initData from '@/mixins/initData'
  import sizeChange from '@/components/public/sizeChange'
  export default {
    name: "index",
    props: {
      status: {
        type: Number,
        default: 0
      },
    },
    components:{
      sizeChange,
      editOrAdd,
      querySelect,
      auditDialog,
      payDialog,
    },
    watch: {
      status(newValue, oldValue) {
        this.selected = [];
        this.page = 1;
        this.init();
      }
    },
    data() {
      return {
        addDialogShow: false,
        active: false,
        //被选择的数据
        selected: [],
        auditDialogShow: false,

        ids: [],
        orderList: [],
        payDialogShow: false,
      }
    },
    mixins: [initData],
    mounted(){
      this.init();
    },
    computed: {
      isMultiple() {
        return this.status === 1 || this.status === 2;
      },

      text(){
        return this.status == 1 ? '审核': '支付';
      },
      multipleFlag(){
        return this.isMultiple && this.selected.length >0;
      }
    },
    methods: {
      beforeInit(){
        this.url = '/pms/crm/pageWalletTrans';
        this.params = {
          page: this.page,
          size: this.size,
        }
        if(this.status){
          this.params.status = this.status;
        }
        if(this.words){
          this.params.basicInfo = this.words;
        }
        if(this.$refs.queryselect.channel){
          this.params.channel = this.$refs.queryselect.channel;
        }
        if(this.$refs.queryselect.type){
          this.params.type = this.$refs.queryselect.type;
        }
        if(this.$refs.queryselect.idStatus){
          this.params.status = this.$refs.queryselect.idStatus;
        }
        if(this.$refs.queryselect.time.length){
          this.params.startTime = this.$refs.queryselect.time[0];
        }
        if(this.$refs.queryselect.time.length){
          this.params.endTime = this.$refs.queryselect.time[1];
        }
        return true;
      },
      getActive(row){
         return row.tradeUrl;
      },
      orderIdHandle(row){
        if(row.tradeUrl){
          window.open(row.tradeUrl);
        }
      },
      getChannelType(tr){
        if(tr.channel === 'personal'){
          return '个人';
        }else {
          return tr.channel ;
        }
      },
      getType(tr){
        switch (tr.type) {
          case 1:
            return '转入（上链）';
          case 2:
            return '转入（非上链）';
          case 3:
            return '转出（上链）';
          case 4:
            return '转出（非上链) ';
        }
      },
      getStatus(tr){
        switch (tr.status) {
          case 1:
            return '待审核';
          case 2:
            return '待支付';
          case 3:
            return '已支付';
          case 4:
            return '已支付';
          case 5:
            return '已完成';
          case 6:
            return '审核拒绝';
        }
      },
      closeHandle(){
        this.active = false;
      },
      payHandle(tr){
        let hanlderInfo = {
          ...tr,
          selected: true,
        }
        this.orderList = [hanlderInfo];
        this.payDialogShow = true;
      },
      auditHandle(tr){
        this.ids = [tr.transactionId];
        this.auditDialogShow = true;
      },
      closeAuditDialog(){
        this.auditDialogShow = false;
      },
      sureHandle(params){
        let paramsData = {
          ...params,
          ids: this.ids
        }
        auditWalletTrans(paramsData).then((res) => {
          console.log(res);
          this.selected = [];
          this.$vs.notify({
            text:'操作成功',
            position: 'top-right'
          });
          this.$emit('refresh');
          this.init();
        })
      },
      acceptIds(ids){
        payWalletTrans({ids}).then((res) => {
          console.log(res);
          this.selected = [];
          this.payDialogShow = false;
          this.$vs.notify({
            text:'支付成功',
            position: 'top-right'
          });
          this.init();
        })
      },
      closePayDialog(){
        this.payDialogShow = false;
      },
      handleSelectIds(){
        this.ids = [];
        for (let i = 0; i < this.selected.length; i++) {
          this.ids.push(this.selected[i].transactionId);
        }
      },
      multipleHandle(){
        if(this.status == 1){
          this.handleSelectIds();
          this.auditDialogShow = true;
        }else {
          let fliterArr = this.selected.filter((item) => {
            item.selected = true;
            return true;
          })
          this.orderList = JSON.parse(JSON.stringify(fliterArr));
          this.payDialogShow = true;
        }
      }
    },
  }
</script>
<style lang="scss">
  .role {
    .vs-table--thead th {
      padding-top: 17px!important;
      padding-bottom: 17px!important;
      color: #5E5873;
      background-color: #F3F2F7;
    }
  }
</style>
<style lang="scss" scoped>
  .role-icon {
    margin-left: 10px;
  }
  .vs-self-tooltip {
    display: inline-block;
  }
  .centerx {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .query-box {
    margin-bottom: 1.7rem;
  }
  .page-header {
    .header-right {
      .search-words {
        display: inline-block;
      }
      .search-btn,
      .search-words {
        margin-right: 10px;
      }
    }
  }
  .page-content {
    padding-bottom: 1.4rem;
  }
  .status-th {
    min-width: 120px;
  }
  .remark-th,
  .type-th {
    min-width: 150px;
  ;
  }
  .remark-th {
    min-width: 100px;
  }
  .asset-status {
    padding: 2px 10px;
    background: rgba(40, 199, 111, 0.12);
    color: #41B883;
    border-radius: 17px;
    font-size: 12px;
    &.red {
      background-color: rgba(234, 84, 85, 0.12);
      color: #EA5455;
    }
    &.gray {
      background-color: rgba(128, 128, 128, 0.12);
      color: gray;
    }
  }
  .merchant-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;

  }
  .check-icon {
    font-size: 22px;
  }
  .channel-th {
    min-width: 80px;
  }
  .statistics {
    background-color: #ffffff;
    padding: 0 1.8rem;
    padding-bottom: 2rem;
    .card {
      background-color: #F8F8F8;
      height: 5rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .data {
        font-weight: bold;
        color: #5E5873;
      }
    }
  }
  .done-icon {
    font-size: 20px;
  }
  .amount-th {
    min-width: 140px;
  }
  .order-span {
    &.on {
      color: #5D9EF8;
    }
  }
</style>
